import { render, staticRenderFns } from "./carrepair.vue?vue&type=template&id=2f3ab5d4"
import script from "./carrepair.vue?vue&type=script&lang=js"
export * from "./carrepair.vue?vue&type=script&lang=js"
import style0 from "./carrepair.vue?vue&type=style&index=0&id=2f3ab5d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports